import Vue from 'vue';

export default function useFocusOnShowDirective() {
    Vue.directive('focus-on-show', {
        inserted(el) {
            const $el = $(el);

            if ($el.is(':visible')) {
                $el.focus();
            }
        }
    });
}